module.exports = __webpack_public_path__ + "static/tabhopweb-af9619dca864b24a6da2ba2d211ea2b3.png";